/**
 * Avisos e Campanhas — exportacao CSV.
 *
 * As regras pt-BR moram AQUI, num lugar so, pelo mesmo motivo de broadcastCsv.js
 * existir do lado da importacao:
 *  - separador ';' — e o que o Excel pt-BR abre em colunas com duplo clique;
 *  - toda celula entre aspas, aspas dobradas — nome de empresa tem ';' e '"';
 *  - CRLF entre linhas;
 *  - BOM UTF-8 na frente — sem ele o Excel le como Windows-1252 e os acentos
 *    viram lixo.
 * E a mesma receita de migracaoAsaas.vue (exportCsv) e do AdvancedReportService
 * da API.
 *
 * Numero sai CRU, sem toLocaleString: "1.234" seria relido pelo Excel pt-BR
 * como o decimal 1,234.
 */

const BOM = '\uFEFF';

/**
 * Nome e e-mail vem de cadastro de cliente; celula que comeca com = + - @ e
 * executada como formula pelo Excel/LibreOffice na maquina do operador. O
 * apostrofo na frente transforma a celula em texto puro. Numero passa cru:
 * nunca e formula e a marca estragaria a contagem.
 */
const FORMULA_PREFIX = /^[=+\-@]/;

const cell = (value) => {
  if (value === null || value === undefined) return '""';
  let text = String(value);
  if (typeof value === 'string' && FORMULA_PREFIX.test(text)) {
    text = "'" + text;
  }
  return '"' + text.replace(/"/g, '""') + '"';
};

export const toCsv = (head, rows) =>
  [head].concat(rows).map((row) => row.map(cell).join(';')).join('\r\n');

const pad = (n) => (n < 10 ? '0' + n : '' + n);

/** dd/MM/yyyy HH:mm:ss, montado a mao: toLocaleString varia entre navegadores. */
export const csvDateTime = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear() + ' ' +
         pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
};

/**
 * `incomplete` entra NO NOME de proposito: o arquivo sai da tela e perde o aviso
 * que a tela mostrava. Um CSV parcial sem marca e lido como o total.
 */
export const csvFileName = (base, incomplete, now) => {
  const d = now || new Date();
  const slug = String(base || 'exportacao')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'exportacao';

  return slug + '-' + d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
         (incomplete ? '-INCOMPLETO' : '') + '.csv';
};

export function saveBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadCsv(head, rows, fileName) {
  saveBlob(new Blob([BOM + toCsv(head, rows)], { type: 'text/csv;charset=utf-8;' }), fileName);
}

export const SUMMARY_HEAD = ['Seção', 'Item', 'Métrica', 'Valor'];

/**
 * Conversao da campanha + "Por superficie" em formato LONGO (uma metrica por linha): as duas
 * tabelas tem colunas diferentes, e lado a lado num CSV so dariam celulas vazias.
 * Assim o arquivo filtra e vira tabela dinamica sem retrabalho.
 *
 * `hasClickStage` segue a tela: nota de versao nao tem clique a medir, e exportar
 * "Clicaram: 0" faria parecer fracasso.
 */
export const summaryRows = (data, surfaces, hasClickStage) => {
  const totals = data || {};
  const rows = [
    ['Conversão da campanha', 'Campanha', 'Empresas direcionadas', totals.targetedCompanies || 0],
    ['Conversão da campanha', 'Campanha', 'Entregues (pessoas)', totals.delivered || 0],
  ];

  if (hasClickStage) rows.push(['Conversão da campanha', 'Campanha', 'Clicaram (pessoas)', totals.clickers || 0]);

  (surfaces || []).forEach((surface) => {
    rows.push(['Por superfície', surface.label, 'Entregues', surface.delivered || 0]);
    rows.push(['Por superfície', surface.label, 'Dispensas', surface.dismissed || 0]);
    rows.push(['Por superfície', surface.label, 'Cliques', surface.clicks || 0]);
    rows.push(['Por superfície', surface.label, 'Clicaram', surface.clickers || 0]);
  });

  return rows;
};



// WEBPACK FOOTER //
// ./src/vue/pages/restricted/broadcast/broadcastExport.js